import { stories } from '@/mocks/stories';
import { liveUpdates } from '@/mocks/site';

const guideTips = [
  { icon: 'ri-eye-line', text: '先看信源：当事人账号与官方声明优先级最高' },
  { icon: 'ri-git-branch-line', text: '再看时间线：有矛盾的时间点往往藏着反转' },
  { icon: 'ri-forbid-2-line', text: '截图先别转：未核实内容容易变成下一轮误会' },
];

export default function LiveTracker() {
  const ranked = stories.slice(0, 5);

  return (
    <section id="live" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-3 border-l-4 border-primary-500 pl-4 md:pl-6">
          <span className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <span className="flex h-2.5 w-2.5 items-center justify-center">
              <span className="h-2 w-2 rounded-full bg-primary-500 animate-soft-pulse" />
            </span>
            LIVE TRACKING
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">实时追踪</h2>
          <p className="max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            热点时段的每一条新进展都在这里滚动补齐，标注来源类别与更新时间，先刷这一栏，再决定要不要深挖。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="flex items-center justify-between border-b border-background-200 bg-background-50 px-5 py-4">
                <h3 className="font-heading text-base font-bold text-foreground-950">更新流</h3>
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
                  <i className="ri-refresh-line" />
                  自动刷新中
                </span>
              </div>

              <ul>
                {liveUpdates.map((item) => (
                  <li
                    key={`${item.time}-${item.title}`}
                    className="flex gap-4 border-b border-background-100 px-4 py-4 last:border-0 transition-colors hover:bg-background-100/70 md:px-5"
                  >
                    <div className="flex w-20 flex-shrink-0 flex-col items-start md:w-24">
                      <span className="whitespace-nowrap text-xs font-medium text-foreground-500">{item.time}</span>
                      <span
                        className={`mt-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] ${
                          item.hot
                            ? 'bg-primary-100 text-primary-800'
                            : 'bg-secondary-100 text-secondary-800'
                        }`}
                      >
                        {item.tag}
                      </span>
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm leading-relaxed text-foreground-900">{item.title}</p>
                      <p className="mt-1.5 flex items-center gap-1.5 text-xs text-foreground-400">
                        <i className="ri-link" />
                        来源：{item.source}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <aside className="flex flex-col gap-6">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-fire-fill text-primary-500" />
                热度榜 · 今日
              </h3>
              <ol className="mt-4 flex flex-col gap-3">
                {ranked.map((story, index) => (
                  <li key={story.id} className="flex gap-3">
                    <span
                      className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                        index < 3
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {index + 1}
                    </span>
                    <div className="min-w-0">
                      <a
                        href="#trending"
                        className="line-clamp-2 text-sm leading-snug text-foreground-900 transition-colors hover:text-primary-600"
                      >
                        {story.title}
                      </a>
                      <span className="mt-1 block text-xs text-foreground-400">热度 {story.heat}</span>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-secondary-900">
                <i className="ri-compass-3-line" />
                蹲后续指南
              </h3>
              <ul className="mt-4 flex flex-col gap-3">
                {guideTips.map((tip) => (
                  <li key={tip.text} className="flex items-start gap-2.5 text-sm leading-relaxed text-secondary-900">
                    <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center">
                      <i className={`${tip.icon} text-base text-secondary-600`} />
                    </span>
                    {tip.text}
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}